import React, { FC, useEffect, useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';

import { useAppSelector } from 'application/hooks/redux';
import { useCompanyPaymentMethods } from 'application/hooks/useCompanyPaymentMethods';

import { useStripeLoader } from 'features/subscription-payment/hooks/useStripeLoader';

import StripePaymentForm from '../StripePaymentForm';

import { StripePaymentProps, StripeTheme } from './models';
import { Wrapper } from './styles';

const StripePayment: FC<StripePaymentProps> = ({
  onPaymentSuccess,
  onPaymentFailed,
}) => {
  const { creditPaymentData } = useAppSelector(
    (state) => state.employeesManagement,
  );
  const { getPaymentMethods, paymentMethods } = useCompanyPaymentMethods();
  const { getStripePromise } = useStripeLoader();

  const appearance = {
    theme: 'stripe' as StripeTheme,
  };
  const options = {
    clientSecret: creditPaymentData?.clientSecret || '',
    appearance,
  };

  const stripePromise = useMemo(() => {
    return getStripePromise();
  }, []);

  useEffect(() => {
    getPaymentMethods();
  }, []);

  const currentPrice = creditPaymentData?.amountToCharge
    ? creditPaymentData?.amountToCharge / 100
    : 0;

  return (
    <Wrapper>
      {creditPaymentData?.clientSecret && (
        <Elements options={options} stripe={stripePromise}>
          <StripePaymentForm
            price={String(currentPrice)}
            clientSecret={creditPaymentData?.clientSecret}
            paymentMethods={paymentMethods}
            onPaymentSuccess={onPaymentSuccess}
            onPaymentFailed={onPaymentFailed}
          />
        </Elements>
      )}
    </Wrapper>
  );
};

export default StripePayment;
